
    require('../../revered/components/additional');

    /**
     * Подгрузка посылок при scrolling
     */

    scrollAutoLoadEnable();

    window.reviewsScrollAutoload = function ( html){

        $('.data-scroll-load-enabled').before(html);

    }

    /**
     * Инициализация карты
     */

    if (typeof ymaps !== 'undefined'){
        ymaps.ready(mapInit);
    }

    function mapInit() {

        let myMap = new ymaps.Map('review_map', {
            center: [55.753994, 37.622093],
            zoom: 5,
            controls: ['typeSelector', 'fullscreenControl', 'zoomControl']
        }, {
            restrictMapArea: [
                [-50, -167.99],
                [80, 192]
            ],
            minZoom: 5,
        })

        let clusterer = new ymaps.Clusterer({
            preset: 'islands#invertedVioletClusterIcons',
            groupByCoordinates: false,
            clusterDisableClickZoom: false,
            clusterHideIconOnBalloonOpen: false,
            geoObjectHideIconOnBalloonOpen: false
        })


        let geoObjects = []

        for (let el in grouped_reviews) {

            const parts = el.split(', ');


            let placemark = new ymaps.Placemark(
                [parts[0], parts[1]],
                {
                    iconContent: grouped_reviews[el].length,
                },
                {
                    preset: 'islands#violetIcon',
                    openEmptyBalloon: true,
                    balloonPanelMaxMapArea: 0,
                }
            )

            placemark.events.add('balloonopen', function (e) {

                let fbTitleString = ``
                let fbContentString = ``

                for (let review of grouped_reviews[el]) {


                    fbTitleString += `<div class="package-feedback-selector" data-id="${review.package_id}">Отзыв №${review.package_id}</div>`;
                    fbContentString += `<div class="package-feedback-wrapper" style="display: none;" data-id=${review.package_id}>${review.html}</div>`;

                }

                let htmlString = `<div class="rm-buble-wrapper" style="min-height: 300px; overflow-x: hidden; overflow-y: auto; display: flex; flex-direction: row;">`
                htmlString += `<div class="rm-buble-wrapper--overflow rm-buble-wrapper--titles" style="width: 150px">${fbTitleString}</div>`
                htmlString += `<div class="rm-buble-wrapper--overflow" style="width: 250px">${fbContentString}</div>`
                htmlString += `</div>`

                placemark.properties.set('balloonContent', htmlString);

                try {
                    document.querySelector(`.package-feedback-selector:first-child`).click()
                } catch (err) {
                }

            });

            geoObjects.push(placemark);
        }

        clusterer.add(geoObjects);

        myMap.geoObjects.add(clusterer);

    }

    /**
     * При клике в попапе в списке отзывов, показать нужный отзыв
     */
    eventClick('.package-feedback-selector', function (data) {

        $(".package-feedback-selector").removeClass("package-feedback-selector--active");

        $(data).addClass("package-feedback-selector--active");

        const selected_id = $(data).data('id');

        $(".package-feedback-wrapper").each(function() {
            if ($(this).data('id') == selected_id) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    })

    /**
     *   Подписка на рассылку новостей
     */
    eventClick('.main-subscription__submit', function (){

        request('POST', `news-subscription`, {email: $('.main-subscription__input').val()}, function (response) {
            showSuccess(response);
            $('.main-subcribe').hide();
        })
    })


